import { heroStats } from "@/mocks/catalog";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20stage%20with%20warm%20amber%20bokeh%20lights%20and%20deep%20brown%20shadows%2C%20soft%20film%20grain%20texture%2C%20dramatic%20spotlight%20beam%20sweeping%20across%20a%20dark%20velvet%20backdrop%2C%20elegant%20minimal%20composition%2C%20moody%20editorial%20atmosphere%2C%20no%20people&width=1920&height=1080&seq=yua-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85"></div>
      </div>

      <div className="relative mx-auto flex min-h-[560px] w-full max-w-content flex-col justify-center px-4 pb-14 pt-28 md:min-h-[720px] md:px-8 md:pb-20 md:pt-32">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-white/5 px-3 py-1 text-xs font-medium tracking-wide text-background-100 backdrop-blur-sm">
            <i className="ri-bookmark-3-line"></i>
            作品 · 合集 · 列表 · 大全 · 系列 · 推荐
          </span>

          <h1 className="mt-5 max-w-3xl font-heading text-3xl font-semibold leading-tight text-background-50 md:text-5xl">
            三上悠亚电影：作品、合集与系列的中文资料整理
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
            这里把与「三上悠亚电影」相关的浏览方向集中整理成一个页面：先说明作品整体范围，再分别介绍合集、列表与大全的查看方式，
            最后补充系列与推荐两个扩展方向。页面下方还提供一份可以在本页直接筛选与检索的条目清单，帮你快速定位想看的内容方向。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#catalog"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-list-check-2"></i>
              浏览条目清单
            </a>
            <a
              href="#overview"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-white/5 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-white/15"
            >
              <i className="ri-compass-3-line"></i>
              先了解内容结构
            </a>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 border-t border-background-50/15 pt-6 md:mt-16 lg:grid-cols-4 lg:gap-5">
          {heroStats.map((stat) => (
            <div key={stat.id} className="animate-fade-in">
              <div className="font-heading text-2xl font-semibold text-accent-400 md:text-3xl">{stat.value}</div>
              <div className="mt-1 text-sm font-medium text-background-50">{stat.label}</div>
              <p className="mt-1 hidden text-xs leading-relaxed text-background-100/70 sm:block">{stat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}